// src/hooks/use-onboarding-chat.ts
import { useState } from "react";
import { useToast } from "@/hooks/use-toast";

interface ChatResponse {
  success: boolean;
  response: string;
  shouldContinueFlow: boolean;
}

export function useOnboardingChat() {
  const { toast } = useToast();
  const [isProcessing, setIsProcessing] = useState(false);

  const processUserMessage = async (
    message: string,
    currentStage: string,
    context?: Record<string, any>
  ): Promise<ChatResponse | null> => {
    setIsProcessing(true);

    try {
      const response = await fetch("/api/onboarding/chat", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          message,
          currentStage,
          context,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to process message");
      }
      console.log(response,"response...")

      const data: ChatResponse = await response.json();
      return data;
    } catch (error) {
      console.error("Error processing user message:", error);
      toast({
        title: "progress",
        description: "Failed to process your message. Please try again..",
        variant: "default",
      });
      return null;
    } finally {
      setIsProcessing(false);
    }
  };

  return {
    processUserMessage,
    isProcessing,
  };
}